import { TextField, styled } from '@mui/material';

const StyledTextField = styled(TextField)({
  '& .MuiInputBase-input': {
    fontSize: '1rem',
    padding: '12px',
    textAlign: 'right',
    fontVariantNumeric: 'tabular-nums',
  },
});

export default StyledTextField;
